import moment from "moment";

export const isoDateFormat = "YYYY-MM-DD HH:mm:ss";

export function formatFromDate(dateToFormat: Date) {
    return moment(dateToFormat).format("MMM DD, YYYY HH:mm");
}

export function formatFromDateWithSeconds(dateToFormat: Date) {
    return moment(dateToFormat).format("MMM DD, YYYY HH:mm:ss");
}

export function formatFromString(dateToFormat: string) {
    return moment(dateToFormat).format("MMM DD, YYYY HH:mm");
}

export const dateToUtcIsoString = (date: Date): string => {
    const momentDate = moment(date);
    const utcDate = new Date(
        Date.UTC(
            momentDate.year(),
            momentDate.month(),
            momentDate.date(),
            momentDate.hour(),
            momentDate.minute(),
            momentDate.second(),
            momentDate.millisecond(),
        ),
    );
    return utcDate.toISOString();
};
